
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crm",
      function () {
        return require("private-next-pages/crm/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crm"])
      });
    }
  